﻿$.fn.dxCtrlContentFormulaire = function custom_dxCtrlContentFormulaire(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentformulaire dx-ctrl");
        this.createInstance(new cdxCtrlContentFormulaire(this, option));
    }
    return this;
}

window.cdxCtrlContentFormulaire = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivContentInner = null;
    var jauge = null;
    function mConstruit() {
        container.empty();
        container.css("position", "relative")
        if (option.data.fini == "1") { container.addClass("texture_import_disable_projet_pipeline") }
        else { container.removeClass("texture_import_disable_projet_pipeline") }
        container.css("border-top", theme.border)

        if (typeof option.data.id_fichier != 'undefined') {
            //on est sur un fichier
            if (option.data.id_fichier != null) {
                option.bddCtrl.mAjaxCall({
                    command: "getdataemailfichier",
                    path_nom_fichier: option.data.id_fichier
                }, function (data) {
                    dataHtml = data
                    mRempliContent(dataHtml)
                })
            } else {
                dataHtml = {
                    html: '<html assistant2="1"><body></body></html>',
                    urlHtml: ""
                }
                mRempliContent(dataHtml)
            }
            isNewFile = (option.data.id_fichier == null)

            var popupPage = page.mGetPopupPage(option.data)
            if (popupPage != null) {
                var onbeforeclose = popupPage.option("onBeforeClose")
                popupPage.option("onBeforeClose", function (e) {
                    if (dxCtrlFormulaireHtml.isDirty()) {
                        dxCtrlFormulaireHtml.mStopSaveAuto()
                    }
                    if (typeof onbeforeclose != 'undefined') { return onbeforeclose(e) }
                    else { return true }
                })
            }
        } else {
            if (option.bddCtrl.getObjet(option.data).cle() != null) {
                //courrier en modification
                option.bddCtrl.mAjaxCall({
                    command: "getdataemailbdd",
                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                    id: option.bddCtrl.getObjet(option.data).cle()
                }, function (data) {
                    dataHtml = data
                    mRempliContent(dataHtml)
                })
            } else {
                dataHtml = {
                    html: '<html assistant2="1"><body></body></html>'
                }
                mRempliContent(dataHtml)
            }
        }
    }

    function mRempliContent(dataHtml) {
        container.empty()
        container.css("border-box", "content-box")
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")

        //if (typeof option.data.id_fichier != "undefined") {
        //    $DivPath = $("<div style='width:100%;text-align:right;font-size:80%;padding:0 5px 5px 0;'/>").appendTo(container)
        //    mRempliPath()
        //}

        var $DivEntete = $("<div style='width:100%;padding:0 0px 0px 0px;'/>").appendTo(container)
        if (typeof option.data.id_fichier == 'undefined') {
            //on est sur des data bdd
            var dxTabs = $("<div/>").appendTo($DivEntete).dxTabs({
                dataSource: ["Formulaire", "Réponses"],
                selectedItem: "Formulaire",
                onItemClick: function (e) {
                    switch (e.itemData) {
                        case "Formulaire": mRempliAssistant(); break;
                        case "Réponses": mRempliReponse(); break;
                    }
                }
            })
        }

        var $DivContent = $("<div style='width:100%;height:calc(100% - " + ($DivEntete.innerHeight()) + "px);' class='divcontent'/>").appendTo(container)
        $DivContentInner = $("<div style='width:100%;height:100%;'/>").appendTo($DivContent)
        resizeObserver.mAdd($DivEntete, function () { $DivContent.css("height", "calc(100% - " + (($DivEntete.is(":visible")) ? $DivEntete.innerHeight() : 0) + "px)") })

        mRempliAssistant()


        mRempliBt()


        mRempliTaille()

    }

    var dxCtrlFormulaireHtml = null
    function mRempliAssistant() {
        if (dxCtrlFormulaireHtml) {
            dxGridReponse.element().remove()
            dxCtrlFormulaireHtml.element().css("display", "")
        } else {
            $DivContentInner.empty()
            var firstLoad = true;
            var opt = {
                bddCtrl: option.bddCtrl,
                path_nom_fichier: option.data.id_fichier,
                data: option.data,
                dataHtml: dataHtml,
                allowFullScreen: option.allowFullScreen,
                onSave: function () {
                    option.data.id_fichier = dxCtrlFormulaireHtml.option("path_nom_fichier")
                    mRempliPath()
                },
                onContentReady: function (component) {
                    if (firstLoad) {
                        firstLoad = false
                        jauge.mHide();
                        if (component) component.focus()
                        //Sauvegarde pour les nouveau fichiers
                        if (typeof option.data.id_fichier == 'undefined' || option.data.id_fichier == null) component.mSave()
                    }
                }
            }
            //if (typeof option.data.id_fichier == "undefined") {
            //    opt.onSlide = function (isSlideDown) {
            //        if (isSlideDown) {
            //            $DivEntete.slideDown(300)
            //        } else {
            //            $DivEntete.slideUp(300)
            //        }
            //    }
            //}

            dxCtrlFormulaireHtml = $("<div style='width:100%;height:100%;'/>").appendTo($DivContentInner).dxCtrlContentFormulaireHtml(opt).dxCtrlContentFormulaireHtml("instance")
        }

    }

    var dxGridReponse = null
    function mRempliReponse() {
        dxCtrlFormulaireHtml.element().css("display", "none")
        var opt = {
            bddCtrl: option.bddCtrl
        }
        opt.lstLstConditionBase = [[{ nom_champ: "id_formulaire", ope: "=", valeur: [{ value: option.data.id_formulaire }] }]]
        dxGridReponse = $("<div style='width:100%;'/>").appendTo($DivContentInner).dxCtrlGridFormulaireReponse(opt).dxCtrlGridFormulaireReponse("instance")
    }

    var lstItemToolBarSource = null
    var eleTaille = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []

        if (typeof option.data.id_fichier != 'undefined') {
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'never',
                width: "100%",
                template(itemData, itemIndex, itemElement) {
                    $DivPath = itemElement
                    itemElement.addClass("state-hover")
                    mRempliPath()
                }
            })

            //taille
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'never',
                width: "100%",
                template(itemData, itemIndex, itemElement) {
                    eleTaille = $("<span style='font-size:80%;' title='" + "'>" + "</span>").appendTo(itemElement)
                    mRempliTaille()
                }
            })
            itemsToolbar.push(getToolbarSeparator())
        }

        itemsToolbar.push({
            location: (typeof option.data.id_fichier == 'undefined' ? 'before' : 'after'),
            locateInMenu: (typeof option.data.id_fichier == 'undefined' ? "never" : "auto"),
            width: (typeof option.data.id_fichier == 'undefined' ? "100%" : null),
            template(itemData, itemIndex, itemElement) {
                mRempliBt()
                function mRempliBt() {
                    if (dxCtrlFormulaireHtml.isInit) {
                        $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                            labelMode: 'floating',
                            label: "Titre du formulaire",
                            hint: "Le titre du formulaire est utilisé pour le titre de la page internet.",
                            value: dxCtrlFormulaireHtml.objet(),
                            width: (typeof option.data.id_fichier == 'undefined' ? 300 : 200),
                            onValueChanged: function (e) {
                                dxCtrlFormulaireHtml.objet((e.value == null) ? "" : e.value)
                            },
                            onContentReady: function (e) {
                                window.setTimeout(function () { e.component.focus(); }, 500)
                                itemElement.find('.dx-texteditor-input').off('keydown.next')
                                itemElement.find('.dx-texteditor-input').on('keydown.next', function (e) {
                                    const key = e.key || e.keyCode || e.which;
                                    if (key === 'Enter' || key === 13) {
                                        e.preventDefault();
                                        let inputs = $('.dx-texteditor-input:visible');
                                        let index = inputs.index(this);
                                        if (index > -1 && index + 1 < inputs.length) {
                                            inputs.eq(index + 1).focus();
                                        }
                                    }
                                });
                            }
                        })
                    } else { window.setTimeout(function () { mRempliBt() }, 50) }
                }
            },
        })
        if (typeof option.data.id_fichier == 'undefined') {
            //on sur des datas
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-anchor",
                        icon2: "fas fa-copy",
                        colorIcone2: theme.colorBtIcon2,
                        opacityIcone2: "0.9",
                        txtTooltip: "Copier le lien du sondage pour utilisation.",
                        onClick: function (e) {
                            var url = option.bddCtrl.getObjet(option.data).objetMetier.mGetUrlLink()
                            var $temp = $("<input>");
                            $("body").append($temp);
                            $temp.val(url).select();
                            document.execCommand("copy");
                            $temp.remove();
                            mNotify("L'adresse du sondage <a href='javascript:void(0)'>" + url + "</a> a été copiée dans le presse-papier", "success", 6000)
                        }
                    });
                },
            })
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-arrow-up-right-from-square",
                        txtTooltip: "Créer une réponse au formulaire<br/>Votre formulaire sera affiché dans une page de votre navigateur et vous créera une ligne de réponse à celui-ci comme pour un répondant réel.<br/>Vous pouvez ainsi créer des réponses (et les supprimer par la suite).",
                        onClick: function (e) {
                            var url = option.bddCtrl.getObjet(option.data).objetMetier.mGetUrlLink()
                            window.open(url, "_blank")
                        }
                    });
                },
            })
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                template(itemData, itemIndex, itemElement) {
                    var opt = {
                        icon: "fas fa-copy",
                        hint: "Dupliquer le formulaire",
                        onClick: function (e) {
                            if (!option.bddCtrl.objCptCli.objetMetier.hasEmail()) {
                                mNotify("Vous n'avez pas les formulaires dans votre offre", "error", 10000)
                                return
                            }
                            option.bddCtrl.mAjaxCall({ command: "duplikformulaire", id: option.data.id_formulaire }, function (data) {
                                page.mAddPopup(option.bddCtrl.getObjet("formulaire", data.id_formulaire).data, { fullScreen: true })
                                jaugeDemarrage.mHide()
                            })
                            page.mRemovePopup(option.data)
                        }
                    }
                    $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
                },
            })
            itemsToolbar.push(getToolbarSeparator())
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                template(itemData, itemIndex, itemElement) {
                    var $Table = $("<table/>").appendTo(itemElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td/>").appendTo($Tr)
                    $("<div style=''/>").appendTo($Td).dxCtrlSwitch({
                        txtTooltip: "Fermer/ouvrir le formulaire<br/>Un formulaire fermé n'est plus accessible.",
                        value: (option.data.fini == "1"),
                        onValueChanged: function (e) {
                            option.data.fini = ((e.value) ? "1" : "0")
                            option.bddCtrl.getObjet(option.data).mSaveChamp("fini")
                            if (option.data.fini == "1") { container.addClass("texture_import_disable_projet_pipeline") }
                            else { container.removeClass("texture_import_disable_projet_pipeline") }
                        }
                    });
                    var $Td = $("<td style='opacity:" + ((option.data.fini == "1") ? "1" : "0.2") + "'>Fermé</td>").appendTo($Tr)
                },
            })
        }

        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    onClick: function (e) {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "25px")
                                $("<div style='padding-bottom:15px;'>Mettre le formulaire<br/>à la corbeille</div>").appendTo(contentElement)
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Confirmez",
                                    onClick: function (e) {
                                        tt.hide()
                                        if (typeof option.data.id_fichier == 'undefined') {
                                            option.bddCtrl.getObjet(option.data).mDelData()
                                            page.mRemovePopup(option.data)
                                        } else {
                                            var actionF = new cFileManagerAction(option.bddCtrl, option.data.id_fichier, "corbeille",
                                                function () {
                                                    var popupPage = page.mGetPopupPage(option.data)
                                                    if (popupPage != null) popupPage.mDestroy()
                                                    //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
                                                })
                                            actionF.mStartTraitement()
                                        }
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance");
                        tt.show();
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)

    }

    function mRempliTaille() {
        if (typeof option.data.taille_octet != 'undefined' && eleTaille != null) {
            eleTaille.empty()
            var $Span = $("<div style='" + ((option.data.taille_octet == 0) ? "display:none;" : "") + "'>" + option.data.taille_octet.sizeFile(2, true) + "</div>").appendTo(eleTaille)
            if (option.data.taille_octet_ss_image.sizeFile(2) != option.data.taille_octet.sizeFile(2)) $Span.attr("title", "Poids message: " + option.data.taille_octet.sizeFile(2, true) + "<br/>" + "(Sans image: " + option.data.taille_octet_ss_image.sizeFile(2, true) + ")")
        }
    }

    var $DivPath = null
    var pathRempli = false
    function mRempliPath() {
        if (typeof option.data.id_fichier != 'undefined' && option.data.id_fichier != null && option.data.id_fichier.length > 0) {
            if (!pathRempli) {
                $("<div/>").appendTo($DivPath).dxCtrlSaveDocFile({
                    bddCtrl: option.bddCtrl,
                    pathNomFichier: option.data.id_fichier,
                    onChangeFileName: function (pathNomFichier) {
                        option.data.id_fichier = pathNomFichier
                    }
                })
                pathRempli = true
            }
        } else if ($DivPath != null) { $DivPath.empty(); $DivPath.off("click"); }
        mRempliTaille()
    }

    var dxPopupInterneClose = null
    function mSaveNewAndQuitte() { //pour les fichiers
        dxPopupInterneClose = $("<div/>").appendTo(((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container))).dxCtrlPopupInterne({
            bddCtrl: option.bddCtrl,
            itemTemplate: function (contentElement) {
                var $Div = $("<div style='font-size:200%;font-weight:bold;padding:15px;text-align:center;'>Sauver votre courrier</div>").appendTo(contentElement)
                var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:50%'/>").appendTo($Tr)
                var $TdContainerAccordion = $("<td style='width:250px;min-width:380px;'/>").appendTo($Tr)
                var $Td = $("<td style='width:50%'/>").appendTo($Tr)

                //le ctrl gere tout sur le serveur
                $("<div/>").appendTo($TdContainerAccordion).dxCtrlSaveNewFile({
                    bddCtrl: option.bddCtrl,
                    deleteSource: true,
                    path_nom_fichier: option.data.id_fichier,
                    onValideSameNameFile: function (newPathNomFichier) {
                        var popupPage = page.mGetPopupPage({ id_fichier: option.data.id_fichier })
                        if (popupPage != null) popupPage.mDestroy()
                        //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
                    },
                    onValideNewNameFile: function (newPathNomFichier) {
                        var popupPage = page.mGetPopupPage({ id_fichier: option.data.id_fichier })
                        if (popupPage != null) popupPage.mDestroy()
                        //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
                    },
                    onCancel: function () {
                        option.bddCtrl.mAjaxCall({
                            command: "filedelete",
                            path_nom_fichier: option.data.id_fichier
                        })
                        var popupPage = page.mGetPopupPage({ id_fichier: option.data.id_fichier })
                        if (popupPage != null) popupPage.mDestroy()
                        //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
                    }
                })
            },
            onClose: function () { dxPopupInterneClose = null }
        }).dxCtrlPopupInterne("instance")
    }

    this.element = function () { return container }

    mConstruit();
}